export const IMAGE_CONSTANTS = {
  icWorkType: '/images/ic_work_type.svg',
  icWorkTypeShuttle: '/images/ic_work_type_shuttle.svg',
  icWorkTypeYard: '/images/ic_work_type_yard.svg',

  // Task card icons (from Xamarin)
  arrow: '/icons/arrow.svg',
  moveTask: '/icons/move_task.svg',
  moveTaskDark: '/icons/move_task_dark.svg',
  auditTask: '/icons/audit_task.svg',
  auditTaskDark: '/icons/audit_task_dark.svg',
  auditTaskCritical: '/icons/audit_task_critical.svg',
  auditTaskHigh: '/icons/audit_task_high.svg',
  criticalIcon: '/icons/critical_icon.svg',
  criticalWhiteIcon: '/icons/critical_white_icon.svg',
  highIcon: '/icons/high_icon.svg',
  highWhiteIcon: '/icons/high_white_icon.svg',
  greenCheck: '/icons/green_check.svg',
  startTask: '/icons/start_task.svg',
  taskCancelIcon: '/icons/ic_task_cancel.svg',
  completedMobile: '/icons/completed_mobile.svg',
  exceptionMobile: '/icons/exception_mobile.svg',

  // Completed insights bar icons (from Xamarin)
  totalTask: '/icons/total_task.svg',
  moveBlue: '/icons/move_blue.svg',
  auditBlue: '/icons/audit_blue.svg',

  // Bottom navigation tab icons (from Xamarin)
  myTaskSelected: '/icons/mytask_selected.svg',
  myTaskUnselected: '/icons/mytask_unselected.svg',
  upcomingSelected: '/icons/upcoming_selected.svg',
  upcomingUnselected: '/icons/upcoming_unselected.svg',
  completedSelected: '/icons/completed_selected.svg',
  completedUnselected: '/icons/completed_unselected.svg',

  // Search bar icons (from Xamarin)
  filterDropdown: '/icons/filter_dropdown.svg',

  // ViewAction popup icons (from Xamarin)
  closeIcon: '/icons/close_icon.svg',
  moveDetails: '/icons/move_details.svg',
  auditDetails: '/icons/audit_details.svg',

  // In-progress task bar icons (from Xamarin)
  inprogressTimerMobile: '/icons/inprogress_timer_mobile.svg',
  inprogressClock: '/icons/inprogress_clock.svg',
  completeTask: '/icons/complete_task.svg',
  smallArrow: '/icons/small_arrow.svg',
  smallArrowDark: '/icons/small_arrow_dark.svg',
  yardJockey: '/icons/yard_jockey.svg',
  yardJockeyDark: '/icons/yard_jockey_dark.svg',

  // In-progress task detail modal icons (from Xamarin DashboardPage BottomSheet)
  expand: '/icons/expand.svg',
  sourcePinBlue: '/icons/source_pin_blue.svg',
  destinationPinBlue: '/icons/destination_pin_blue.svg',
  userBlue: '/icons/user_blue.svg',
  transitTruck: '/icons/transit_truck.svg',

  // Notification icons (from Xamarin)
  notificationBell: '/icons/notification_bell.svg',
  noNotification: '/icons/no_notification.svg',
  moveSmall: '/icons/move_small.svg',
  auditSmall: '/icons/audit_small.svg',
  // Create Move Task icons
  trailerCard: '/images/ic_trailer.svg',

  // Yard Capacity Dashboard icons (from Xamarin)
  yardCapacityEmpty: '/images/yard_capacity_someting_went_wrong.svg',
  // Create Audit Task icons
  dockEmpty: '/images/dock_door.svg',
  dockTrailer: '/images/ic_trailer.svg',
  yard: '/images/yard.svg',
  appGuideScrollArrow: '/icons/appguide_scroll_arrow.svg',

  // Complete task dialog icons (from Xamarin CompletedTaskPopUp)
  allGood: '/icons/all_good.svg',
  exception: '/icons/exception.svg',
  icSubmit: '/icons/ic_submit.svg',
} as const;
